/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchInteractionBatchResponse
 */
export interface SearchInteractionBatchResponse {
    /**
     * Number of events accepted
     * @type {number}
     * @memberof SearchInteractionBatchResponse
     */
    accepted: number;
}

/**
 * Check if a given object implements the SearchInteractionBatchResponse interface.
 */
export function instanceOfSearchInteractionBatchResponse(value: object): value is SearchInteractionBatchResponse {
    if (!('accepted' in value) || value['accepted'] === undefined) return false;
    return true;
}

export function SearchInteractionBatchResponseFromJSON(json: any): SearchInteractionBatchResponse {
    return SearchInteractionBatchResponseFromJSONTyped(json, false);
}

export function SearchInteractionBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInteractionBatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accepted': json['accepted'],
    };
}

export function SearchInteractionBatchResponseToJSON(json: any): SearchInteractionBatchResponse {
    return SearchInteractionBatchResponseToJSONTyped(json, false);
}

export function SearchInteractionBatchResponseToJSONTyped(value?: SearchInteractionBatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accepted': value['accepted'],
    };
}

